import config from '../config.json';
import http from './httpService';

export const getAllArea = ({cancelToken}) => {
    return http.get(config.api_area, {cancelToken});
}

export const createArea = (dress) => {
	return http.post(`${config.api_area}`, dress);
}

export const updateAreaById = (_id, dress) => {
	return http.patch(`${config.api_area}/${_id}`, dress);
}

export const deleteAreaById = (_id) => {
	return http.delete(`${config.api_area}/${_id}`);
}
